import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
// import { analyticsMiddleware as analytics } from '../analytics';

import reducers from './reducers';

const DEV = process.env.NODE_ENV !== 'production';

// Transient UI state that must never be persisted. localStorage is shared
// across tabs, so a persisted `modals` slice meant opening a second tab
// rehydrated whatever modal was open in the first one — on whatever route that
// tab landed on, since <Modals /> is mounted globally in the Main layout.
// `notifications` is a toast queue and is stale by the time it rehydrates.
const TRANSIENT = ['modals', 'notifications'];

// redux-persist applies `blacklist` on write only (createPersistoid), never on
// read. A blob written before these keys were blacklisted still carries them,
// so rehydration would replay the stale modal exactly once more per browser.
// Strip them on the way in too; the next write drops them from storage for good.
const stateReconciler = (inboundState, originalState, reducedState, config) => {
  const cleanInbound = { ...inboundState };
  TRANSIENT.forEach((key) => delete cleanInbound[key]);

  return autoMergeLevel2(cleanInbound, originalState, reducedState, config);
};

const persistConfig = {
  key: 'buypoweradmin',
  storage,
  blacklist: TRANSIENT,
  stateReconciler,
};

let middleware = [thunk];

if (DEV) {
  // Dev Mode middleware
  const logger = createLogger({ collapsed: true });
  middleware.push(logger);
}

if (!DEV) {
  // Prod Mode middleware
}

let composers = [applyMiddleware(...middleware)];

if (DEV) {
  // Redux Dev Tools Extension
  composers.push(
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : (a) => a
  ); // Enable Redux Dev Tools;
}

const initStore = (initialState) => {
  const reducer = persistCombineReducers(persistConfig, reducers);

  const store = createStore(reducer, initialState, compose(...composers));

  const persistor = persistStore(store);

  return { store, persistor };
};

export default initStore;
